import React from 'react';
import { Inbox, Plus } from 'lucide-react';
import './QueryStateView.scss';

/**
 * QueryEmptyState Component
 * Displays an engaging empty state with icon, title, description, and primary CTA.
 *
 * @param {Object} props
 * @param {string} [props.title='No records found']
 * @param {string} [props.description='There is no data to display at this moment.']
 * @param {React.ReactNode} [props.icon]
 * @param {string} [props.actionLabel]
 * @param {Function} [props.onAction]
 * @param {string} [props.className='']
 */
export const QueryEmptyState = ({
  title = 'No records found',
  description = 'There is no data to display at this moment.',
  icon,
  actionLabel,
  onAction,
  className = '',
}) => {
  return (
    <div className={`query-state-empty ${className}`} role="status">
      <div className="query-empty-icon-wrapper">
        {icon || <Inbox className="query-empty-icon" size={40} />}
      </div>
      <h4 className="query-empty-title">{title}</h4>
      {description && <p className="query-empty-description">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          className="query-empty-action-btn"
          onClick={onAction}
        >
          <Plus size={16} />
          <span>{actionLabel}</span>
        </button>
      )}
    </div>
  );
};

export default QueryEmptyState;
